import { object } from 'yup'

export default {
  doNotConvertKeysToSnakeCase: false,
  Schema: object(),
} as const
